<div class="wrapper">
    <div class="section ">
        <div class="container">
            <div class="row mb-4">
                <div class="col-md-12 ml-auto mr-auto text-center">
                    <h1 class="title mt-2">IMPUESTO PREDIAL</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 pr-md-0">
                    <div class="card card-pricing  bg-default my-4">
                        <div class="card-body px-lg-4">
                           
                        </div>
                    </div>
                </div>

                <div class="col-md-7 pl-md-0 ">
                    <div class="card card-pricing border-0 text-center ">
                        <div class="card-header bg-transparent ">
                            <h4 class="text-uppercase ls-1 text-primary py-2 mb-0">DESGLOSE DEL ADEUDO</h4>
                        </div>
                        <div class="card-body px-lg-6 pb-0 pt-1">
                            <table class="table table-bordered mt-3 ">
                                <tbody>
                                   
                                    <tr>
                                        <td>Clave Catastral:</td>
                                        <td>{{forma.ClaveCatastral}}</td>
                                    </tr>
                                    <tr>
                                        <td>Nombre del Propietario:</td>
                                        <td>{{forma.NombrePropietario}}</td>
                                    </tr>
                                  
                                    <tr>
                                        <td>Ubicación del Predio:</td>
                                        <td>{{forma.UbicacionPredio}}</td>
                                    </tr>
                                    <tr>
                                        <td>Fecha Actual:</td>
                                        <td>{{fecha | date:'dd-MM-yyyy'}}</td>
                                    </tr>
                                    <tr>
                                        <td>Terreno:</td>
                                        <td>{{forma.Terreno}} M2</td>
                                    </tr>
                                    <tr>
                                        <td>Construcción:</td>
                                        <td>{{forma.Construccion}} M2</td>
                                    </tr>
                                <tr>
                                    <td>Valor Catastral:</td>
                                    <td>{{forma.ValorCatastral | currency}}</td>
                                </tr>

                                  
                                    <tr>
                                        <td>Periodo:</td>
                                        <td>{{forma.BimestreInicial}}</td>
                                    </tr>
                                    <tr>
                                        <td>Impuesto Corriente</td>
                                        <td>{{forma.ImpuestoCorriente | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Impuesto Rezago:</td>
                                        <td>{{forma.ImpuestoRezago | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Diferencia Corriente:</td>
                                        <td>{{forma.DiferenciaCorriente | currency }}</td>
                                    </tr>
                                    <tr>
                                        <td>Diferencia Rezago:</td>
                                        <td>{{forma.DiferenciaRezago | currency }}</td>
                                    </tr>
                                    <tr>
                                        <td>Recargo Corriente:</td>
                                        <td>{{forma.RecargoCorriente | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Recargo Rezago:</td>
                                        <td>{{forma.RecargoRezago | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Ejecución Corriente:</td>
                                        <td>{{forma.EjecucionCorriente | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Ejecución Rezago:</td>
                                        <td>{{forma.EjecucionRezago | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Honorarios Corriente:</td>
                                        <td>{{forma.HonorariosCorriente | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Honorarios Rezago:</td>
                                        <td>{{forma.HonorariosRezago | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Bonificación Pronto Pago:</td>
                                        <td>{{forma.BonificacionPago | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Bonificación Pensionado:</td>
                                        <td>{{forma.BonificacionPensionado | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Descuento:</td>
                                        <td>{{forma.Descuento | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Ajuste:</td>
                                        <td>{{forma.Ajuste | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Importe a pagar:</td>
                                        <td>{{forma.ImporteTotal | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Fecha límite de pago:</td>
                                        <td>{{forma.fecha_limite | date:'dd-MM-yyyy' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer ">
                            <button class="btn btn-primary mb-3" type="button" data-target="#modal-notification"
                                (click)="enviar(m)">
                                PAGO EN LINEA
                            </button>
                        </div>
                    </div>


                </div>
            </div>

            <div class="row">
                <div class="text-center text-dark w-100">
                    <i class="fas fa-info-circle  fa-3x"></i>
                    <h6 class="text-dark mt-2">SI EL RECIBO DE PAGO NO IMPRIME</h6>
                    <p>Favor de notificar al correo de: <br> <span
                            class="font-weight-bolder">predial@nld.gob.mx</span><br> y al día siguiente al confirmarlo
                        en nuestro banco, le enviamos escaneado su recibo.</p>

                    <h6 class="text-dark mt-2">SI REQUIERE FACTURA</h6>
                    <p>Solicitarla al correo electronico, debe ser el mismo día de pago, enviando su cédula fiscal.</p>
                </div>
            </div>
        </div>
        <div aria-hidden="true" aria-labelledby="modal-notification" bsModal class="modal fade" #m="bs-modal"
            id="modal-notification" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-white modal-dialog-centered modal-" role="document">
                <div class="modal-content ">
                    <div class="modal-header">
                        <div class="col-10">
                            <h6 class="modal-title font-weight-bolder" id="modal-title-notification">
                                Ingrese datos de método de pago
                            </h6>
                            <p class="mt-2">Solo se aceptan tarjetas VISA o MasterCard.</p>
                        </div>
                      
                    </div>
                    <div class="modal-body">
                        <form role="form" ngNativeValidate #f="ngForm">
                        <!---->    
                            <div class="row">
                                <div class="col-5">
                                    <div class="form-group">
                                        <label>Nombre</label>
                                        <input [(ngModel)]="modal.nombre" name="nombre" class="form-control text-dark" required type="text" placeholder="">
                                    </div>
                                </div>
                                <div class="col-7">
                                        <div class="form-group">
                                            <label>Apellidos</label>
                                            <input [(ngModel)]="modal.apellidos" name="apellidos" class="form-control text-dark" required type="text"
                                                placeholder="">
                                        </div>
                                </div>
                            </div>
                            
                            
                            <div class="form-group">
                                <label>Correo Electronico</label>
                                <input [(ngModel)]="modal.correo" name="correo" class="form-control text-dark" required type="text" placeholder="">
                            </div>
                            <div class="form-group">
                                <label>Teléfono(solo numeros)</label>
                                <input [(ngModel)]="modal.telefono" name="telefono" numbersOnly class="form-control text-dark" required type="number" 
                                                      minlength="10"   maxlength="10" placeholder="10 digitos">
                            </div>
                            <div class="row">
                                <div class="col-8">
                                    <div class="form-group">
                                        <label>Dirección</label>
                                        <input [(ngModel)]="modal.direccion" name="direccion" class="form-control text-dark" required type="text"
                                            placeholder="">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label>Codigo Postal</label>
                                        <input [(ngModel)]="modal.codigopostal" name="codigopostal" numbersOnly class="form-control text-dark" required
                                            type="text" placeholder="">
                                    </div>
                                </div>
                            </div>    
                          
                            <br>
                            <div class="form-group">
                                <label>Número de tarjeta<span style="color:red">(Usar tarjeta digital)</span></label>
                                <input [(ngModel)]="modal.Card" name="Card" numbersOnly maxlength="16" minlength="16"
                                    class="form-control text-dark" required type="text"
                                    placeholder="ESCRIBE EL NÚMERO DE TARJETA DÉBITO/CRÉDITO">
                            </div>
                            <div class="form-group">
                                <label>Tipo de Tarjeta<span style="color:red">CREDITO O DEBITO</span></label>
                                <select [(ngModel)]="modal.type" required name="type" class="form-control text-dark">
                                    <option value="DB">DEBITO</option>
                                    <option value="CR">CREDITO</option>
                                   
                                </select>
                            </div>
                            <div class="form-group">
                                <label>CVV</label>
                                <input [(ngModel)]="modal.CVV" required name="CVV" numbersOnly minlength="3"
                                    maxlength="3" class="form-control text-dark" type="text"
                                    placeholder="ESCRIBE LOS TRES DÍGITOS QUE ESTÁN AL REVERSO DE SU TARJETA">
                            </div>
                            <div class="form-group ">
                                <label>Fecha de vencimiento</label><br>
                                <div class="row">
                                    <div class="col-6">
                                        <label>Mes</label>
                                        <select [(ngModel)]="modal.mes" required name="mes"
                                            class="form-control text-dark">
                                            <option value="01">01</option>
                                            <option value="02">02</option>
                                            <option value="03">03</option>
                                            <option value="04">04</option>
                                            <option value="05">05</option>
                                            <option value="06">06</option>
                                            <option value="07">07</option>
                                            <option value="08">08</option>
                                            <option value="09">09</option>
                                            <option value="10">10</option>
                                            <option value="11">11</option>
                                            <option value="12">12</option>
                                        </select>
                                    </div>
                                    <div class="col-6">
                                        <label>Año</label>
                                        <select [(ngModel)]="modal.year" required name="year"
                                            class="form-control text-dark">
                                            <option *ngFor="let year of years" [value]="year.value">{{year.year}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <img style="width: 40px;" class="mr-2" src="assets/img/predial/visa.jpg"
                                    [ngClass]="{'box-sombra': modal.Card.charAt(0)=='4'}">
                                <img style="width: 40px;" src="assets/img/predial/mastercard.jpg"
                                    [ngClass]="{'box-sombra': modal.Card.charAt(0)=='5'}">
                            </div>
                            <div class="text-center">
                                <button class="btn btn-primary  mt-4" [disabled]="!f.valid" type="button"
                                    (click)="pagarV2()">
                                    EFECTUAR PAGO
                                </button>
                              <!--  <button class="btn btn-secondary  mt-4" [disabled]="!f.valid" type="button" (click)="pagarV2()">
                                    EFECTUAR PAGO
                                </button>-->
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-link text-dark ml-auto" data-dismiss="modal" (click)="m.hide()"
                            type="button">
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>